module.exports = __webpack_public_path__ + "ceb41fd1990457761e83ce962cdefb06.png";